import createHeaders from "@utils/createHeaders";

export const headers = createHeaders ([
  { text: 'No', value: 'number_index', width: '10' },
  { text: 'Bill Number', value: 'bill_num' },
  { text: 'Aggregator Name', value: 'aggregator_name'},
  { text: 'Merchant Name', value: 'merchant_name'},
  { text: 'MID', value: 'mid'},
  { text: 'Merchant PAN', value: 'mpan'},
  { text: 'Reff ID', value: 'rrn'},
  { text: 'QR Method', value: 'qr_method'},
  { text: 'QR Type', value: 'qr_type'},
  { text: 'Transaction Type', value: 'trx_type'},
  { text: 'Issuer Name', value: 'issuer_name' },
  { text: 'Customer PAN', value: 'customer_pan'},
  { text: 'Customer Name', value: 'customer_name'},
  { text: 'Payment Type', value: 'payment_type'},
  { text: 'Acquirer Name', value: 'payment_channel'},
  { text: 'Amount', value: 'amount'},
  { text: 'MDR', value: 'amount_mdr'},
  { text: 'Net Amount', value: 'amount_net'},
  { text: 'Transaction Date', value: 'trx_datetime'},
  { text: 'Status', value: 'status'},
  { text: 'Settlement Status', value: 'settlement_status'},
  { text: 'Settlement Date', value: 'settlement_datetime'},
  { text: 'Source of Fund', value: 'payment_method'},
  { text: 'Additional Data', value: 'additional_data'},
  { text: 'Promo Code', value: 'promo_code'},
  { text: 'Switcher Name', value: 'switcher_name'},
  { text: 'Action', value: 'action', align: 'center', textAlign: 'text-center', width: '10' },
]);

export const search = {
  trx_datetime: [],
  ac_id: '',
  payment_type: '',
  rrn: '',
  mid: '',
  status: '',
  bill_num: '',
  promo_code: '',
  qr_method: ''
};

export const editedItem = {
  bill_num: '',
  merchant_name: '',
  mid: '',
  mpan: '',
  rrn: '',
  qr_method: '',
  qr_type: '',
  trx_type: '',
  customer_pan: '',
  payment_method: '',
  payment_type: '',
  payment_channel: '',
  amount: '',
  currency: '',
  amount_mdr: '',
  net_amount: '',
  trx_datetime: '',
  status: '',
  settlement_status: '',
  promo_code: '',
  product_indicator: '',
};
